import { internationalBeneficiaryFieldName } from '@routable/fund-routes';
export const individualIdFieldNameOptions = [
    {
        id: 1,
        label: 'National Identity Card (Cédula de Ciudadanía)',
        value: internationalBeneficiaryFieldName.Enum.co_cc,
    },
    {
        id: 2,
        label: 'Foreigners Identification Card (Carnet Extranjeria)',
        value: internationalBeneficiaryFieldName.Enum.co_ce,
    },
    { id: 3, label: 'Passport (Pasaporte)', value: internationalBeneficiaryFieldName.Enum.co_pass },
    {
        id: 4,
        label: 'Special Permit of Permanence (Permiso Especial de Permanencia)',
        value: internationalBeneficiaryFieldName.Enum.co_pep,
    },
];
